type LogoutHandler = () => void

let logoutHandler: LogoutHandler | null = null

export function registerLogoutHandler(handler: LogoutHandler): void {
    logoutHandler = handler
}

export function unregisterLogoutHandler(handler: LogoutHandler): void {
    if (logoutHandler === handler) {
        logoutHandler = null
    }
}

export function triggerLogoutHandler(): void {
    logoutHandler?.()
}
